import React, { useState } from 'react';
import '../assets/styles/AvatarPicker.css';

const AVATAR_OPTIONS = [
    // Baby Animals (All Available!)
    '🐥', '🐣', '🐤', '🐧', '🐰', '🐻', '🐼', '🐨', '🦊', '🐱',
    '🐶', '🐭', '🐹', '🦔', '🐿️', '🦝', '🦙', '🦒', '🦘', '🐸',
    '🐻‍❄️', '🦦', '🦥', '🦫', '🦨', '🦡', '🐾', '🐇', '🐀', '🐁',
    // More Baby/Cute Animals
    '🦁', '🐯', '🐮', '🐷', '🐽', '🐵', '🙈', '🙉', '🙊', '🐒',
    '🐔', '🐓', '🐣', '🦆', '🦅', '🦉', '🦇', '🐺', '🐗', '🐴',
    '🦓', '🦌', '🐑', '🐐', '🦬', '🐘', '🦣', '🦏', '🦛', '🐪',
    '🐫', '🦒', '🦘', '🦬', '🐃', '🐂', '🐄', '🐎', '🐖', '🐏',
    // Ocean & Sea Babies
    '🐙', '🦑', '🐬', '🐳', '🐋', '🐠', '🐟', '🐡', '🦈', '🦀',
    '🦞', '🦐', '🦪', '🐚', '🐢', '🦭', '🐊', '🐍', '🦎', '🐉',
    // Magical & Fantasy
    '🦄', '🐉', '🧚', '🧜', '✨', '🌈', '⭐', '💫', '🌟', '🔮',
    // Bugs & Small Creatures
    '🦋', '🐛', '🐌', '🐞', '🐜', '🪲', '🪳', '🦗', '🪰', '🐝',
    '🪱', '🦠', '🐾',
    // Happy Faces
    '😊', '😎', '🤓', '🥳', '🤩', '😇', '🥰', '😜', '🤗', '🤠',
    // Fun Objects
    '🧸', '🎁', '🎈', '🪁', '🎮', '🎯', '🏆', '🎸', '🎧', '🚀'
];

export default function AvatarPicker({ selectedAvatar, onSelect, size = 'large' }) {
    const [isOpen, setIsOpen] = useState(false);

    const avatarSize = size === 'large' ? '80px' : size === 'medium' ? '60px' : '40px';
    const gridSize = size === 'large' ? '60px' : size === 'medium' ? '50px' : '40px';

    return (
        <div className="avatar-picker">
            <div className="selected-avatar-container">
                <button
                    type="button"
                    className="selected-avatar"
                    onClick={() => setIsOpen(!isOpen)}
                    style={{ fontSize: avatarSize }}
                    aria-label={`Selected avatar: ${selectedAvatar || 'default'}. Click to change.`}
                    aria-expanded={isOpen}
                >
                    {selectedAvatar || '😊'}
                </button>
                <p className="avatar-label">Click to choose your avatar!</p>
            </div>

            {isOpen && (
                <>
                    <div className="avatar-overlay" onClick={() => setIsOpen(false)} />
                    <div className="avatar-grid-container" role="dialog" aria-label="Avatar picker">
                        <div className="avatar-grid-header">
                            <h3>Choose Your Avatar</h3>
                            <button
                                type="button"
                                className="close-button"
                                onClick={() => setIsOpen(false)}
                                aria-label="Close avatar picker"
                            >
                                ✕
                            </button>
                        </div>
                        <div className="avatar-grid">
                            {AVATAR_OPTIONS.map((avatar) => (
                                <button
                                    key={avatar}
                                    type="button"
                                    className={`avatar-option ${selectedAvatar === avatar ? 'selected' : ''}`}
                                    onClick={() => {
                                        onSelect(avatar);
                                        setIsOpen(false);
                                    }}
                                    style={{ fontSize: gridSize }}
                                    aria-label={`Select avatar ${avatar}`}
                                    aria-pressed={selectedAvatar === avatar}
                                >
                                    {avatar}
                                </button>
                            ))}
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}
